import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { setVoucherRequest } from 'Store/Order/actions';
import { getVoucherRequests } from 'Store/Order/selectors';
import { getVoucherContent } from 'Pages/InfoVoucherPage/Redux/selectors';
import FormVoucherPurchase from 'Components/FormVoucherPurchase/FormVoucherPurchase';

interface IPropsInternal {
  isFetching: boolean;
  voucherContent: Julius.Content.VoucherPage;
  voucherRequests: Julius.Website.VoucherRequestViewModel[];
  setVoucherRequest: (request: Julius.Website.VoucherRequestViewModel) => void;
}

type Props = IPropsInternal & RouteComponentProps<{}>;

interface IState {
  amount: number;
  quantity: number;
  isShowingWarningMinValue: boolean;
  isShowingWarningMaxValue: boolean;
}

class FormVoucherPurchaseContainer extends React.PureComponent<Props, IState> {
  private readonly maxValue: number = 10000;
  private readonly minValue: number = 50;

  constructor(props: Props) {
    super(props);

    this.state = {
      amount: this.getInitialAmount(),
      quantity: this.getInitialQuantity(),
      isShowingWarningMinValue: false,
      isShowingWarningMaxValue: false,
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (
      prevProps.voucherRequests.length <
      this.props.voucherRequests.length
    ) {
      this.redirectToPayment();
    }
  }

  getInitialAmount = () => {
    const { voucherRequests } = this.props;
    return voucherRequests && voucherRequests.length > 0 ? 
      voucherRequests[0].amount : 0;
  }

  getInitialQuantity = () => {
    const { voucherRequests } = this.props;
    return voucherRequests && voucherRequests.length > 0 ? 
      voucherRequests[0].quantity : 0;
  }

  onAmountChange = (value: number) => {
    this.setState({ amount: value });
  }

  onQuantityChange = (value: number) => {
    this.setState({ quantity: value });
  }

  onToPaymentClick = () => {
    const isValidRequest = this.validateRequest();

    if (isValidRequest) {
      const { amount, quantity } = this.state;
      this.props.setVoucherRequest({ amount, quantity });
    }
  }

  validateRequest = () => {
    const { 
      amount,
      quantity,
      isShowingWarningMinValue, 
      isShowingWarningMaxValue,
    } = this.state;

    const totalAmount = amount * quantity;

    if (totalAmount < this.minValue) {
      if (!isShowingWarningMinValue) {
        this.setState({ 
          isShowingWarningMinValue: true,
          isShowingWarningMaxValue: false,
        });
      }
      return false;
    }
    
    if (totalAmount > this.maxValue) {
      if (!isShowingWarningMaxValue) {
        this.setState({ 
          isShowingWarningMinValue: false,
          isShowingWarningMaxValue: true,
        });
      }
      return false;
    }

    if (isShowingWarningMinValue || isShowingWarningMaxValue) {
      this.setState({ 
        isShowingWarningMinValue: false,
        isShowingWarningMaxValue: false, 
      });
    }
    return true;
  }

  redirectToPayment = () => {
    const { history } = this.props;
    history.push('/order/presentkort/detaljer');
  }

  render() {
    const { voucherContent } = this.props;
    const text = voucherContent ? voucherContent.purchaseText : null;
    const imageUrl = voucherContent ? voucherContent.purchaseImageUrl : null;

    return (
      <FormVoucherPurchase
        text={ text }
        imageUrl={ imageUrl }
        maxTotalValue={ this.maxValue }
        minTotalValue={ this.minValue }
        onAmountChange={ this.onAmountChange }
        onQuantityChange={ this.onQuantityChange }
        onToPaymentClick={ this.onToPaymentClick }
        { ...this.state }
       />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    voucherRequests: getVoucherRequests(state),
    voucherContent: getVoucherContent(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    setVoucherRequest,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(FormVoucherPurchaseContainer);


// WEBPACK FOOTER //
// ./src/components/FormVoucherPurchase/FormVoucherPurchaseContainer.tsx